export const OPEN_NEW_PROJECT_DIALOG = "NEW_PROJECT_DIALOG/OPEN"
export const CLOSE_NEW_PROJECT_DIALOG = "NEW_PROJECT_DIALOG/CLOSE"

export const openNewProjectDialog =  () => ({ type: OPEN_NEW_PROJECT_DIALOG })
export const closeNewProjectDialog = () => ({ type: CLOSE_NEW_PROJECT_DIALOG })

